export function availMeta(v) {
  const s = v || "";
  if (s.includes("Rajoitetusti")) return { dot: "bg-amber-400", label: s, muted: false };
  if (s.includes("Ei tällä hetkellä") || s === "Varattu") return { dot: "bg-[#B7B0A5]", label: s || "Ei saatavilla", muted: true };
  return { dot: "bg-emerald-500", label: s || "Saatavilla", muted: false };
}

export function videoEmbedUrl(url) {
  if (!url) return null;
  try {
    const u = new URL(url);
    const host = u.hostname.replace("www.", "");
    if (host === "youtu.be") return `https://www.youtube.com/embed/${u.pathname.slice(1)}`;
    if (host.endsWith("youtube.com")) {
      const id = u.searchParams.get("v");
      if (id) return `https://www.youtube.com/embed/${id}`;
      if (u.pathname.startsWith("/embed/")) return url;
    }
    if (host.endsWith("vimeo.com")) {
      const id = u.pathname.split("/").filter(Boolean)[0];
      if (id) return `https://player.vimeo.com/video/${id}`;
    }
  } catch { /* ignore */ }
  return null;
}
